import React from 'react'
import styled from 'styled-components'
import colours from '../lib/colours'
import IconControl from '../controls/icon-control'

const ButtonContainer = styled.button`
  width: 18px;
  height: 18px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 25px;
  padding: 0;
  cursor: pointer;
  transition: background-color 0.3s linear;
`

const DefaultButtonContainer = styled(ButtonContainer)`
  top: 3px;
  background-color: ${colours.lightGray};
  &:hover {
    background-color: ${colours.aquaBackground};
  }
`

interface IProps {
  onClick: any
  styleName?: string
}

const QuestionButton = class extends React.Component<IProps> {
  render() {
    return (
      <DefaultButtonContainer onClick={this.props.onClick}>
        <IconControl icon="question" style={{ fontSize: '9px' }} />
      </DefaultButtonContainer>
    )
  }
}

export default QuestionButton
